import { render, staticRenderFns } from "./Section4.vue?vue&type=template&id=1d65e7c6&"
import script from "./Section4.vue?vue&type=script&lang=js&"
export * from "./Section4.vue?vue&type=script&lang=js&"
import style0 from "./Section4.vue?vue&type=style&index=0&id=1d65e7c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports